import { tv, type VariantProps } from "../../../util/tv";

export const iconCardVariant = tv({
  slots: {
    base: ["flex flex-col"],
    header: ["h-full", "rounded-t-2xl"],
    top: ["flex flex-col items-center"],
    icon: ["flex", "mb-4", "h-8 w-8"],
    title: [],
    description: ["mt-3"],
    list: ["flex flex-col gap-3", "mt-5"],
    footer: ["rounded-b-2xl"],
    link: [],
  },
  variants: {
    theme: {
      dark: {
        base: "text-white",
        icon: "text-blue-400",
        description: "text-gray-60",
      },
      light: {
        base: "text-black",
        icon: "text-blue-100",
        description: "text-gray-60",
      },
    },
    appearance: {
      ghost: {
        base: "w-full h-full",
        footer: "mt-6",
      },
      card: {
        base: ["drop-shadow-md rounded-xl", "w-full h-full"],
        header: "p-6",
        footer: "p-6",
      },
      outline: {
        base: ["rounded-xl border", "w-full h-full"],
        header: "p-6",
        footer: "p-6",
      },
      outlineCentered: {
        base: ["rounded-xl border", "row-span-2"],
        title: ["text-center"],
        description: ["text-center"],
        header: ["p-6", "flex flex-col items-center justify-center"],
        footer: "p-6",
      },
      minimalist: {
        base: ["rounded-xl bg-gray-600", "w-full h-full"],
        description: "text-gray-40",
        header: "p-6",
        footer: "p-6",
      },
      glass: {
        base: [
          "bg-gray-800/40",
          "border border-gray-500 rounded-2xl",
          "w-full h-full",
        ],
        header: "p-6 pb-8",
        title: ["w-full", "text-left"],
        top: ["flex-row-reverse justify-between", "mb-6"],
        footer: ["p-6", "bg-gray-300/30", "border-t border-white/10"],
        icon: ["mb-0"],
        link: "text-blue-300",
      },
    },
    hasFooting: {
      false: {
        header: "rounded-b-2xl",
      },
      true: {},
    },
  },
  compoundVariants: [
    {
      theme: "dark",
      appearance: "card",
      className: {
        header: "bg-gray-800",
        footer: "bg-gray-600",
      },
    },
    {
      theme: "light",
      appearance: "card",
      className: {
        header: "bg-white",
        footer: "bg-gray-1",
      },
    },
    {
      theme: "dark",
      appearance: ["outline", "outlineCentered"],
      className: {
        base: "border-gray-500",
      },
    },
    {
      theme: "light",
      appearance: ["outline", "outlineCentered"],
      className: {
        base: "border-gray-500",
      },
    },
  ],
  defaultVariants: {
    theme: "dark",
    appearance: "ghost",
  },
});

export type IconCardVariantProps = VariantProps<typeof iconCardVariant>;

export type IconCardReturnVariantProps = ReturnType<typeof iconCardVariant>;
